var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',{staticClass:"modal",style:({
    background: this.isBackgroundTransparent ? 'transparent' : '',
  }),on:{"click":function($event){return _vm.closeModalOnClickOutSide($event)}}},[_c('div',{staticClass:"modal_body",style:({
      'min-width': this.minWidth,
      'min-height': this.minHeight,
      top: this.location.y + 'px',
      left: this.location.x + 'px',
    })},[(_vm.isCloseButton)?_c('button',{staticClass:"modal_body_close-btn",on:{"click":_vm.closeModal}},[_vm._v(" X ")]):_vm._e(),_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }